import $http from "@/api/index";
import axios from "axios";
import {
  getToken
} from "../../../util/auth";
const cookieUser = getToken();
const person = {
  ID: cookieUser.userId,
  NAME: cookieUser.realName,
  DEPTID: cookieUser.departmentId,
  DEPTNAME: cookieUser.departmentName,
  COMPANYID: cookieUser.companyId,
  COMPANYNAME: cookieUser.companyName
};

/**
 *创建或者修改会诊信息
 *
 * @export
 * @param {*} model
 * @returns
 */
export function AddOrUpdateConsultation(model) {
  let getUrl = {
    method: "POST",
    url: "remoteConsultation/AddOrUpdateConsultation",
    requestType: 2
  };
  return $http(getUrl, model);
}
//获取所有未读消息
export function GetUnReadRemind(pageIndex, pageSize, userId) {
  let getUrl = {
    method: "GET",
    url: `im/GetUnReadRemind?pageIndex=${pageIndex}&pageSize=${pageSize}&userId=${userId}`,
    requestType: 2
  };
  return $http(getUrl, {});
}
/**
 *获取我的会诊
 *
 * @export
 * @param {*} para
 * @returns
 */
export function GetMyConsultationByPara(paras) {
  let getUrl = {
    method: "POST",
    url: "remoteConsultation/GetMyConsultationByPara",
    requestType: 2
  };
  let params = paras;
  return $http(getUrl, paras);
}

/**
 *
 * 确认会诊时间
 * @export
 * @param {*} id 会诊ID
 * @param {*} time 确认会诊时间
 * @param {*} person 确认人
 * @returns
 */
export function CertainConsultationDatetime(id, time, userList, person) {
  let getUrl = {
    method: "POST",
    url: "remoteConsultation/CertainConsultationDatetime",
    requestType: 2
  };
  let params = {
    Id: id,
    Time: time,
    ExcuteUserList: userList,
    Person: person
  };
  return $http(getUrl, params);
}

export function AddConsultationRecord(model) {
  let getUrl = {
    method: "POST",
    url: "remoteConsultation/AddConsultationRecord",
    requestType: 2
  };
  return $http(getUrl, model);
}

export function GetAllConsultaionRecordList(taskId) {
  let getUrl = {
    method: "GET",
    url: "remoteConsultation/GetAllConsultaionRecordList",
    requestType: 2
  };
  let params = {
    taskId: taskId
  };
  return $http(getUrl, params);
}

export function InviteUserJoin(remoteConsultInvite) {
  let getUrl = {
    method: "POST",
    url: "remoteConsult/InviteUserJoin",
    requestType: 7
  };
  return $http(getUrl, remoteConsultInvite);
}
export function JoinRemoteConsultByEntityId(taskId, userId, entityId) {
  let getUrl = {
    method: "GET",
    url: "remoteConsult/JoinRemoteConsultByEntityId",
    requestType: 7
  };
  let params = {
    taskId: taskId,
    userId: userId,
    entityId: entityId
  };
  return $http(getUrl, params);
}
export function GetMeetingRemoteRecord(mainId) {
  let getUrl = {
    method: "GET",
    url: "remoteConsult/GetMeetingRemoteRecord",
    requestType: 7
  };
  let params = {
    mainId: mainId,
  };
  return $http(getUrl, params);
}
export function StartMeetRemote(userId, inquisitionId, selectType) {
  let getUrl = {
    method: "GET",
    url: "RemoteConsultation/StartMeetRemote",
    requestType: 2
  };
  let params = {
    userId: userId,
    inquisitionId: inquisitionId,
    selectType,
    selectType
  };
  return $http(getUrl, params);
}
export function GetConSultionById(consultionId) {
  let getUrl = {
    method: "GET",
    url: "RemoteConsultation/GetConSultionById",
    requestType: 2
  };
  let params = {
    consultionId: consultionId
  };
  return $http(getUrl, params);
}
//新增患者信息
export function AddPatient(sysPatient) {
  let getUrl = {
    method: "POST",
    url: "patient/AddPatient",
    requestType: 2
  };
  let params = {
    sysPatient: sysPatient
  };
  return $http(getUrl, params);
}
///根据患者Id获取患者信息
export function GetPatientInfoById(Id) {
  let getUrl = {
    method: "GET",
    url: "patient/GetPatientInfoById",
    requestType: 2
  };
  let params = {
    Id: Id
  };
  return $http(getUrl, params);
}
///获取所有患者信息
export function GetAllPatientInfo() {
  let getUrl = {
    method: "GET",
    url: "patient/GetAllPatientInfo",
    requestType: 2
  };
  let params = {}
  return $http(getUrl, params);
}
///新增多个信息
export function AddPatientList(patientsInfo) {
  let getUrl = {
    method: "POST",
    url: "patient/AddPatientList",
    requestType: 2
  };
  let params = {
    patientsInfo: patientsInfo
  }
  return $http(getUrl, params);
}
///根据会诊Id获取患者信息
export function GetPatientInfoByConsultaionId(consultaionId) {
  let getUrl = {
    method: "GET",
    url: "patient/GetPatientInfoByConsultaionId",
    requestType: 2
  };
  let params = {
    consultaionId: consultaionId
  }
  return $http(getUrl, params);
}
export function GetRemoteConsulUserList(inquisitionId) {
  let getUrl = {
    method: "GET",
    url: "RemoteConsultation/GetRemoteConsulUserList",
    requestType: 2
  };
  let params = {
    inquisitionId: inquisitionId
  };
  return $http(getUrl, params);
}
/**
 *通过会诊ID获取问诊信息
 *
 * @export
 * @param {*} consultationId
 * @param {*} userId
 * @returns
 */
export function GetInquisitionInfoByConsultationId(consultationId, userId) {
  let getUrl = {
    method: "GET",
    url: "remoteConsultation/GetInquisitionInfoByConsultationId",
    requestType: 2
  };
  let params = {
    ConsultationId: consultationId,
    UserId: userId
  };
  return $http(getUrl, params);
}

/**
 *
 *新增问诊
 * @export
 * @param {*} inquisition
 * @returns
 */
export function AddInquisition(inquisition) {
  let getUrl = {
    method: "POST",
    url: "remoteConsultation/AddInquisition",
    requestType: 2
  };
  return $http(getUrl, inquisition);
}

/**
 *根据问诊获取会诊信息
 *
 * @export
 * @param {*} inquisitionId
 * @returns
 */
export function GetConsultationByInquisitionId(inquisitionId) {
  let getUrl = {
    method: "GET",
    url: "remoteConsultation/GetConsultationByInquisitionId?inquisitionId=" + inquisitionId,
    requestType: 2
  };
  return $http(getUrl, {});
}

/**
 *
 *问诊填写专家意见
 * @export
 * @param {*} id
 * @param {*} diagnose
 * @param {*} treatment
 * @returns
 */
export function CompleteInquisition(id, diagnose, treatment) {
  let getUrl = {
    method: "post",
    url: `remoteConsultation/CompleteInquisition`,
    requestType: 2
  };
  var para = {
    InquisitionId: id,
    Diagnose: diagnose,
    Treatment: treatment
  };
  return $http(getUrl, para);
}

/**
 *获取问诊详情
 *
 * @export
 * @param {*} id
 * @returns
 */
export function GetInquisitionInfoById(id) {
  let getUrl = {
    method: "get",
    url: `remoteConsultation/GetInquisitionInfoById?inquisitionId=${id}`,
    requestType: 2
  };
  return $http(getUrl, {});
}
export function UpdateInquisionState(inquisitionId, type) {
  let getUrl = {
    method: "GET",
    url: "remoteConsultation/UpdateInquisionState",
    requestType: 2
  };
  let params = {
    inquisitionId: inquisitionId,
    type: type
  };
  return $http(getUrl, params);
}
/// 获取会诊求助
export function GetConsultionHelp(type) {
  let getUrl = {
    method: "GET",
    url: "remoteConsultation/GetConsultionHelp",
    requestType: 2
  };
  let params = {
    type: type,
  };
  return $http(getUrl, params);
}
///新增会诊求助记录
export function AddConsultionHelpRecord(RecordList) {
  let getUrl = {
    method: "post",
    url: `remoteConsultation/AddConsultionHelpRecord`,
    requestType: 2
  };
  let params = {
    RecordList: RecordList,
  };
  return $http(getUrl, params);
}
///获取大屏的求助记录
export function GetRemoteHelpRecordList() {
  let getUrl = {
    method: "GET",
    url: `remoteConsultation/GetRemoteHelpRecordList`,
    requestType: 2
  };
  let params = {};
  return $http(getUrl, params);
}
///获取分类信息
export function GetPatientByCreateUser(queryData) {
  let getUrl = {
    method: "GET",
    url: `remoteConsultation/GetPatientByCreateUser`,
    requestType: 2
  };
  let params = queryData;
  return $http(getUrl, params);
}
///获取分类信息
export function GetConsultationPatientInfoByUserId(queryData) {
  let getUrl = {
    method: "GET",
    url: `remoteConsultation/GetConsultationPatientInfoByUserId`,
    requestType: 2
  };
  let params = queryData;
  return $http(getUrl, params);
}
///专家填写意见并签名
export function InquisitionExpertSign(inquisitionSign) {
  let getUrl = {
    method: "POST",
    url: `remoteConsultation/InquisitionExpertSign`,
    requestType: 2
  };
  let params = {
    inquisitionSign: inquisitionSign
  };
  return $http(getUrl, params);
}
export function GetAttachFileByInquisitionId(InquisitionId) {
  let getUrl = {
    method: "GET",
    url: `remoteConsultation/GetAttachFileByInquisitionId`,
    requestType: 2
  };
  let params = {
    InquisitionId: InquisitionId
  };
  return $http(getUrl, params);
}
///远程会诊浮动求助截图使用
export function RemoteFloatHelp(userId, userName) {
  let getUrl = {
    method: "GET",
    url: `remoteConsultation/RemoteFloatHelp`,
    requestType: 2
  };
  let params = {
    userId: userId,
    userName: userName
  };
  return $http(getUrl, params);
}
///多患者，专家填写签名/诊断意见等
export function AddInquisitionExpertSignList(inquisitionSignList) {
  let getUrl = {
    method: "POST",
    url: `remoteConsultation/AddInquisitionExpertSignList`,
    requestType: 2
  };
  let params = {
    inquisitionSignList: inquisitionSignList
  };
  return $http(getUrl, params);
}
///根据问诊Id来获取专家报告单
export function GetAllInqusioionRecords(InqusioionId) {
  let getUrl = {
    method: "GET",
    url: `remoteConsultation/GetAllInqusioionRecords`,
    requestType: 2
  };
  let params = {
    InqusioionId: InqusioionId,
  };
  return $http(getUrl, params);
}
export function GetAttachFileByInquisitionReocrdId(InquisitionReocrdId) {
  let getUrl = {
    method: "GET",
    url: `remoteConsultation/GetAttachFileByInquisitionReocrdId`,
    requestType: 2
  };
  let params = {
    InquisitionReocrdId: InquisitionReocrdId
  };
  return $http(getUrl, params);
}
///根据会诊报告Id获取数据
export function GetInquisitionRecordId(recordId) {
  let getUrl = {
    method: "GET",
    url: `remoteConsultation/GetInquisitionRecordId`,
    requestType: 2
  };
  let params = {
    recordId: recordId
  };
  return $http(getUrl, params);
}
///接收问诊申请
export function AcceptInquisition(inquisitionId, userId) {
  let getUrl = {
    method: "GET",
    url: `remoteConsultation/AcceptInquisition`,
    requestType: 2
  };
  let params = {
    inquisitionId: inquisitionId,
    userId: userId
  };
  return $http(getUrl, params);
}
///根据常用专家或者常用专家组获取会诊任务
export function GetOftenConsultonById(params) {
  let getUrl = {
    method: "GET",
    url: `remoteConsultation/GetOftenConsultonById`,
    requestType: 2
  };
  return $http(getUrl, params);
}

/**
 *获取视频问诊即将开始数据
 *
 * @export
 * @param {*} 
 * @returns
 */
export function GetAboutToBeginRemote() {
  let getUrl = {
    method: "Get",
    url: "remoteConsultation/GetAboutToBeginRemote",
    requestType: 2
  };
  let params = {}
  return $http(getUrl, params);
}
/**
 *完成会诊
 *
 * @export
 * @param {*} 
 * @returns
 */
export function CompleteConsultation(ConsultationId) {
  let getUrl = {
    method: "Post",
    url: "remoteConsultation/CompleteConsultation ",
    requestType: 2
  };
  let params = {
    ConsultationId: ConsultationId,
    Person: person
  }
  return $http(getUrl, params);
}

/**
 *确认关闭会诊
 *
 * @export
 * @param {*} 
 * @returns
 */
export function ConfirmCompleteConsultation(ConsultationId) {
  let getUrl = {
    method: "Post",
    url: "remoteConsultation/ConfirmCompleteConsultation ",
    requestType: 2
  };
  let params = {
    ConsultationId: ConsultationId,
    Person: person
  }
  return $http(getUrl, params);
}

/**
 *作废会诊
 *
 * @export
 * @param {*} 
 * @returns
 */
export function CancelConsultation(ConsultationId) {
  let getUrl = {
    method: "Post",
    url: "remoteConsultation/CancelConsultation ",
    requestType: 2
  };
  let params = {
    ConsultationId: ConsultationId,
    Person: person
  }
  return $http(getUrl, params);
}
